import { ApprovalCellProps } from './ApprovalCell.types';
import { TableBodyCell } from '../../../../../MyTickets.styled';
import { ApprovalStatusField } from 'src/components/Tickets/common/ApprovalStatusField/ApprovalStatusField';

export const ApprovalCell = ({ approval, hoverPopover }: ApprovalCellProps) => {
  return (
    <TableBodyCell>
      {<ApprovalStatusField hoverPopover={hoverPopover} approval={approval} />}
    </TableBodyCell>
  );
};
